<div class="how-compensate-works" *ngIf="content" [style.backgroundColor]="backgroundColor">
  <div class="how-compensate-works-inner">
    <div class="steps">
      <div class="step" *ngFor="let step of content.fields.steps">
        <img
          *ngIf="step.fields.image"
          class="step__image"
          [src]="step.fields.image.fields.file.url"
          [alt]="step.fields.image.fields.description || ''"
          loading="lazy"
        />
        <div class="step__description" *ngIf="step.fields.description">{{ step.fields.description }}</div>
        <div class="step__link-container" *ngIf="step.fields.stepLink">
          <a
            *ngIf="step.fields.stepLink && step.fields.stepLink.fields.externalLink"
            class="step__link"
            target="_blank"
            rel="noopener noreferrer"
            [href]="step.fields.stepLink.fields.link"
          >
            {{ step.fields.stepLink.fields.title }}
          </a>
          <a
            *ngIf="step.fields.stepLink && !step.fields.stepLink.fields.externalLink"
            class="step__link"
            [routerLink]="step.fields.stepLink.fields.link"
            [queryParams]="step.fields.stepLink.fields.anchor ? { anchor: step.fields.stepLink.fields.anchor } : {}"
          >
            {{ step.fields.stepLink.fields.title }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
